import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer} from '@angular/common';
import { EventInteraction } from '../dynamic/event.interaction.service';
import { APP_SETTINGS } from '../../../modules/ng-express-engine/tokens';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { PubNubEngine } from './pubnub.engine.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs';

export interface PNNotification {
    id: number;
    importance: string;
    interaction: PNNotificationInteraction;
    message: string;
    alertUrl: string;
}

export interface PNSuper {
    description: string;
    id: number;
    series_id?: any;  //number probably
    sorting?: number;
    sub_head: string;
    summary: string;
    title: string;
    live: boolean;
}

export interface PNNotificationInteraction {
    item: PNNotificationInteractionItem;
    unique_id: any;
}

export interface PNNotificationInteractionItem {
    details_url: string;
    obj_type: string;
    slug: string;
    unique_id: any;
}

export interface PNEnvelope {
    key: string;
    received: PNMessage;
}

export interface PNMessage {
    channel: string;
    message: PNItemMessage;
    publish_time: any;
}

export interface PNItemMessage {
    episode_id: number;
    live: boolean;
    liveenabled: string,
    livesteam_url: string,
    recording_type: string,
    selected_show: number,
    selected_show_slug: string,
    spotlight_timestamp: any,
    talk: boolean,
    warmode: boolean,
    super: PNSuper;
    has_notification?: boolean,
    notification?: PNNotification;
}

@Injectable()
export class PubNubNotifier {

    private isClient: boolean
    public messageNotifier : BehaviorSubject<object>;
    public isLive: boolean = false;
    private pubnubObservable: Observable<any>;
    private pubnubSubscription: Subscription;
    public lastMessage: PNEnvelope;
    private hadNotification = false;
    private lastNotificationId: any;
    private lastSuperId: any;
    private lastLiveFlag: any;
    
    constructor(
        private pubnubService: PubNubEngine,
        private interactions : EventInteraction,
        @Inject(PLATFORM_ID) private platformId: string,
        @Inject(APP_SETTINGS) private settings: any
    ){
        this.isClient = isPlatformBrowser(this.platformId);
        this.messageNotifier = new BehaviorSubject(null);
        this.pubnubObservable = this.pubnubService.messageNotifier.asObservable();
        const self = this;
        if (this.isClient && this.settings.PUBNUB_ENABLED){
            this.pubnubSubscription = self.pubnubObservable.subscribe(res =>{
                //self.lastMessage = res;
                self.parseMessageAndEmit(res);
            });
        }
    }

    private parseMessageAndEmit(res){
        let notificationHasChanged = false;
        let superHasChanged = false;
        let notification;
        if (res){
            //res = this.lastMessage;
            res.received.message.super['live'] = res.received.message['live']
            if ((!this.lastSuperId || (this.lastSuperId != res.received.message.super.id)) || (!this.lastLiveFlag || (this.lastLiveFlag != res.received.message.live))){
                superHasChanged = true;
                this.lastSuperId = res.received.message.super.id;
                this.lastLiveFlag = res.received.message.live;
            }
            if (res.received.message['notification']){
                if(res.received.message['notification']['interactions'] && res.received.message['notification']['interactions'].length > 0){
                    res.received.message['has_notification'] = true;
                    const interaction = res.received.message['notification']['interactions'][0];
                    res.received.message['notification']['interaction'] = interaction;
                    delete res.received.message['notification']['interactions'];
                    res.received.message['notification']['alertUrl'] = this.createInteractionRoute(interaction.item.obj_type, interaction.item.slug, interaction.item.details_url);
                    if (!this.lastNotificationId || (this.lastNotificationId != interaction['unique_id'])){
                        notificationHasChanged = true;
                        this.hadNotification = true;
                        this.lastNotificationId = interaction['unique_id'];
                        notification = res.received.message['notification'] as PNNotification;
                    }
                }

            }
            else{
                if (this.hadNotification){
                    notificationHasChanged = true;
                    this.hadNotification = false;
                    this.lastNotificationId = null;
                }
            }
            
            //Notify listeners
            const typedRes = res as PNEnvelope;
            this.lastMessage = typedRes;
            if (this.messageNotifier){ 
                this.messageNotifier.next(typedRes);
            }

            if (notificationHasChanged){
                this.interactions.next({
                    key: "noticationMessageChange",
                    message: notification
                });
            }
            if (superHasChanged){
                this.interactions.next({
                    key: "liveSuperChanged",
                    message: res.received.message.super as PNSuper 
                });
            }
        }
    }

    public getLastValue(): PNEnvelope {
        return this.lastMessage;
    }

    public getLastSuper(): PNSuper {
        return this.lastMessage && this.lastMessage.received.message.super
    }

    public getLastNotification(): PNNotification {
        return this.lastMessage && this.lastMessage.received.message.notification
    }

    private createInteractionRoute(type: string, slug: string, detailsUrl: string)
    {
        let url = "";
        switch(type)
        {
            case "Section" : 
                if(slug == "home")
                {
                    url = "/";
                }
                else
                {
                    url = detailsUrl.replace(this.settings['DATA_API_ENDPOINT'],'');
                }
                break;
            default: url = detailsUrl.replace(this.settings['DATA_API_ENDPOINT'],'');  
 
        }
        return url;
    }

}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/notification/pubnub.notification.service.ts